import { Component, Inject } from '@angular/core';
import { ConfigService } from '@app/services/config/config.service';
import { DSB_DIALOG_DATA } from '@app/services/config/constants';
import { ContentService } from '@app/services/content.service';
import { CUSTOMER_ID, LocalStorageService } from '@app/services/local-storage.service';
import { BrnDialogRef } from '@spartan-ng/brain/dialog';

@Component({
    selector: 'app-confirmation-dialog',
    templateUrl: './confirmation-dialog.component.html',
    styleUrls: ['./confirmation-dialog.component.css'],
    standalone: false,
})
export class ConfirmationDialogComponent {
    constructor(
        public dialogRef: BrnDialogRef<void>,
        @Inject(DSB_DIALOG_DATA) public data: { title: string; description: string },
        private contentService: ContentService,
        private localStorageService: LocalStorageService,
        private readonly configService: ConfigService
    ) {}

    onCancel(): void {
        this.dialogRef.close();
    }

    onLogout(): void {
        this.contentService.sendData(this.contentService.logout);
        this.dialogRef.close();
        this.clearSSOAuthTokensFromCookies();
    }

    protected clearSSOAuthTokensFromCookies() {
        const origin = this.configService.config.authService;
        const customerID = this.localStorageService.getString(CUSTOMER_ID);
        const customerIdWithoutPrefix = customerID?.replace(/.*?(\d+)/, '$1'); //NOSONAR
        const url = `${origin}?customerID=${customerIdWithoutPrefix}&removeExistingTokens=1`;
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = url;
        document.body.appendChild(iframe);
    }
}
